// extracted by mini-css-extract-plugin
export default {"div":"fincasCafeterias_div__lB0GE","img":"fincasCafeterias_img__nKoF-"};